import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M17.688 11.75c0-2.023-1.094-3.883-2.844-4.922a5.71 5.71 0 0 0-5.688 0 5.68 5.68 0 0 0-2.844 4.922c0 2.05 1.067 3.91 2.844 4.95a5.71 5.71 0 0 0 5.688 0c1.75-1.04 2.844-2.9 2.844-4.95M5 11.75a6.95 6.95 0 0 1 3.5-6.043c2.16-1.258 4.813-1.258 7 0C17.66 6.965 19 9.262 19 11.75a7.02 7.02 0 0 1-3.5 6.07c-2.187 1.258-4.84 1.258-7 0A6.96 6.96 0 0 1 5 11.75m4.84 1.723c.41.437 1.12.902 2.16.902a2.89 2.89 0 0 0 2.133-.902.653.653 0 0 1 .93-.055c.273.246.273.656.027.93a4.15 4.15 0 0 1-3.09 1.34c-1.477 0-2.516-.684-3.117-1.34a.68.68 0 0 1 .027-.93.653.653 0 0 1 .93.055m-.902-3.036c0-.464.382-.874.874-.874.493 0 .876.41.876.874a.864.864 0 0 1-.876.876.864.864 0 0 1-.874-.876m4.539.602a.56.56 0 0 1-.793.027.53.53 0 0 1 0-.765c.382-.438.957-.63 1.476-.63.547 0 1.094.192 1.504.63a.554.554 0 0 1-.027.765.53.53 0 0 1-.766-.027 1 1 0 0 0-.71-.273c-.274 0-.548.109-.684.273"
    }, null, -1)
  ]))]))
}
export default { render: render }